const skipped = (ctx: any, value: any) =>
  ctx.p0.skip || ctx.p1.skip ? value : undefined;

const hashStringToNumber = (input: string): number => {
  let hash = 0;
  if (input.length === 0) return hash;

  for (let i = 0; i < input.length; i++) {
    const charCode = input.charCodeAt(i);
    hash = (hash << 5) - hash + charCode;
    hash |= 0;
  }

  return Math.abs(hash);
};

export { hashStringToNumber,skipped };
